import React, { useContext } from "react";
import { Switcher } from "../view/Switcher";
import { deepCopy } from "../utils";
import { TableContext } from "../index";
import { applyMinorChanges } from "../auth/authService";

function RecipientTableRow({ data, index }) {

    const { config, setConfig } = useContext(TableContext);

    const onEnableAlertClick = async (value) => {
        const user = deepCopy(data);
        user.enableAlerting = value;
        await applyMinorChanges(user)
        setConfig({ ...config, lastUpdated: Date.now() });
    }

    return (
        <tr key={index}>
            <td>
                {data.username}
            </td>
            <td>
                {data.firstName}
            </td>
            <td>
                {data.lastName}
            </td>
            <td>
                {data.email}
            </td>
            <td>
                <div>
                    {/* <div className="custom-control custom-switch"> */}
                        <Switcher value={data.enableAlerting} onClick={onEnableAlertClick} />
                    {/* </div> */}
                </div>
            </td>
        </tr>
    )


}

export default RecipientTableRow;